import { helpConstants } from 'Constants/help.constants';

const initialState = {
    responseArray: [],
    usersList:[],
    loading: false,
    totalRecords: 0,
    error:false,
    currentPage:1,
    usersTotalRecords:'',
    usersCurrentPage:'',
    formLoading:false,
    errorElement:'',
    editErrorElement:'',
    exportHelpData: [],
    exportTotalRecords: 0,
    exportLoding: false,
}

export function help(state = initialState, action = {}) {
    const { help } = action;

    switch (action.type) {
        case helpConstants.HELP_REQUEST:
            return { ...state, loading: true, error: null };
        case helpConstants.HELP_GET_SUCCESS:
            return {
                ...state,
                responseArray: ( help ) ? [ ...help ] : [],
                totalRecords: action.totalRecords,
                currentPage: (action.currentPage) ? action.currentPage : state.currentPage,
                loading: false,
                formLoading:false,
                error:false,
            }
        case helpConstants.DELETE_TEAM_SUCCESS:
            return {
                ...state,
                responseArray: state.responseArray.filter(( teamObj ) => {
                    return action.updateObject.ids.indexOf(teamObj.id)
                }),
                totalRecords: state.totalRecords - action.updateObject.updateRecords,
                loading: false,
                error:false
            }
        case helpConstants.TEAM_FAILURE:
            return {
                ...state,
                loading: false,   
                error:true
            }
        case helpConstants.HELP_FORM_REQUEST:
            return { 
                ...state, 
                loading: true, 
                formLoading: true, 
                error: true, 
                errorElement:'', 
                editErrorElement:'' 
            };
        case helpConstants.UPDATE_HELP_SUCCESS:
            return {
                ...state,
                loading: false,
                formLoading:false,
                error: false,
                errorElement: ''
            }
        case helpConstants.HELP_SAVE_FORM_FAILURE:
            return {
                ...state,
                loading: false,  
                formLoading:false, 
                error:true,
                errorElement:action.error
            }
        case helpConstants.HELP_FAILURE:
            return {
                ...state,
                loading: false,  
                formLoading:false, 
                error:true,
                errorElement: action.error
            }
        default:
            return state;
    }
}

export function exportHelpData(state = initialState, action = {}) {
    const { exportData, totalRecords, error } = action;
    switch (action.type) {
        case helpConstants.EXPORT_HELP_REQUEST:
            return { ...state, exportLoding: true, error: null }
        case helpConstants.EXPORT_HELP_SUCCESS:
            return { ...state, exportLoding: false, exportHelpData: exportData, exportTotalRecords: totalRecords }
        case helpConstants.EXPORT_HELP_FAILURE:
            return { ...state, exportLoding: false, error: error }
        default:
            return state;
    }
}
